import VueRouter from 'vue-router';
import { afterEachGuard, beforeEachGuard } from '@/guards/pixGlobal.guard.js';
import routes from './routes.js';
import Vue from 'vue';

Vue.use(VueRouter);

/* Init vue router */
const router = new VueRouter({
  mode: 'history',
  routes,
});

/* Hook before each navigation to a new page */
router.beforeEach(beforeEachGuard);

/* Hook after each navigation to a new page */
router.afterEach(afterEachGuard);

export default router;
